/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { V1UpdateUserRequestInput } from '../../entities/v1/UpdateUserRequestInput'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { v1DocumentDataSchema } from './documentDataSchema'
import { v1TransportDataSchema } from './transportDataSchema'
import { z } from 'zod'

export const v1UpdateUserRequestInputSchema = z.object({
  birthday: z.string().optional(),
  documents: z.array(z.lazy(() => v1DocumentDataSchema)).optional(),
  drivee_city_id: z.number().int(),
  drivee_user_id: z.number().int(),
  email: z.string().optional(),
  first_name: z.string().optional(),
  last_name: z.string().optional(),
  middle_name: z.string().optional(),
  phone: z.string(),
  transport: z.lazy(() => v1TransportDataSchema).optional(),
  transport_type_id: z.number().int(),
  transport_year: z.string().optional(),
}) as unknown as ToZod<V1UpdateUserRequestInput>